import { sortBooksByScore } from '../utils.js';
import StarRating from './StarRating.jsx';
import { Trophy, BookOpen, Star } from 'lucide-react';
import { useState } from 'react';
import BookDetailsPopUp from './BookDetailsPopUp.jsx';
import StartVotingPopUp from './StartVotingPopUp.jsx';
import ChooseReadingDeadlinePopUp from './chooseReadingDeadlinePopUp.jsx';

function RankedList(props) {
  console.log("RankedList received onSetReadingDeadline:", props.onSetReadingDeadline);


    const rankedSuggestions = sortBooksByScore(props.suggestions.suggestedBooks || []);
    const isVotingActive = props.isVotingActive;
    const [ showSugBookDetail, setShowSugBookDetail ] = useState(false);
    const [ showStartVotingPopUp, setShowStartVotingPopUp ] = useState(false);
    const [ selectedBook, setSelectedBook ] = useState(null);
    const [showSetReadingDeadline, setShowSetReadingDeadline] = useState(false); 

    function closeACB() {
        setShowSugBookDetail(false);
        setSelectedBook(null);
    }
    function openACB(book) {
        setSelectedBook(book);
        setShowSugBookDetail(true);
    }

  return (
    <div className="space-y-6">

      {/* Ranked Suggestions - Main Focus */}
      <div>
        <h3 className="text-amber-900 mb-4">Current Suggestions</h3>
        <div className="space-y-3">
          {/* kommer rendera alla förslag från redan en sorterad lista */}
          {rankedSuggestions.map((book, index) => {
            const totalPoints = book.totalScore;
            const voteCount = book.voters.length;

            return (
                <div 
                key={book.bookId} 
                onClick={() => {
                  if (showSetReadingDeadline) return;
                  openACB(book)}}
                className="rounded-lg p-4 !border border-amber-200 hover:shadow-md transition-shadow cursor-pointer"
                >
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="flex items-center justify-center w-12">
                    {(index === 0 && (
                      <Trophy className="w-6 h-6 text-amber-500 fill-amber-500" />
                    ))}
                    {index !== 0 && (
                      <span className="text-amber-600">#{index + 1}</span>
                    )}
                  </div>
                  
                  <img
                    src={book.bookImg}
                    alt={book.title}
                    className="mx-auto sm:w-16 sm:h-24 w-24 object-cover rounded shadow"
                  />
                  
                  <div className="flex-1">
                    <h4 className="text-amber-900 mb-1">{book.title}</h4>
                    <p className="text-amber-600 mb-2">{book.author}</p>
                    <div className="flex gap-2 mb-3">
                      <span key="genre" className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs">{book.genre}</span>
                      <span key="pages" className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs">{book.pages} pages</span>
                    </div>
                    {isVotingActive ? (
                      <StarRating
                        bookId={book.bookId}
                        currentRating={book.voters.find(v => v.userId === props.currentUser.userId)?.score || 0}
                        readonly={!true}
                        onRate={(score) => {props.onVote(book.bookId, props.currentUser.userId, score);}}
                      />
                    ):(                      
                        <p className="text-amber-600 text-sm italic">Voting period not active</p>
                      )}
                  </div>

                  <div className="flex flex-col items-start sm:items-end gap-3 text-left sm:text-right">
                    
                      {voteCount > 0 ? (
                        <>
                          <div className="flex items-center gap-1 mb-1">
                            <Star className="w-5 h-5 fill-amber-400 text-amber-400" />
                            <span className="text-amber-900">{totalPoints}</span>
                          </div>
                          <div className="text-xs text-amber-600">{voteCount} vote{voteCount !== 1 ? 's' : ''}</div>
                        </>
                      ) : (
                        <div className="text-xs text-amber-400">No votes yet</div>
                      )}
                      {!isVotingActive && index === 0 && props.isAdmin && (
                        <>
                          <button
                            key={book.bookId}
                            onClick={(event) => {
                              event.stopPropagation();
                              setShowSetReadingDeadline(true);
                            }}
                            className="mt-2 px-3 py-1 bg-amber-500 text-white !rounded-lg text-sm hover:bg-amber-600 transition-colors"
                          >
                            Choose winning book
                          </button>
                          <ChooseReadingDeadlinePopUp onSetReadingDeadline={props.onSetReadingDeadline}
                            onChosenBook={()=>props.onChoosenBook(book)}
                            show={showSetReadingDeadline}
                            setShow={setShowSetReadingDeadline}
                          />
                        </>
                        
                      )}
                  </div>
                </div>
              </div>
            );
          })}
            <BookDetailsPopUp
                    show={showSugBookDetail}
                    setShow={setShowSugBookDetail}
                    book={selectedBook}
                    suggested={true}
                    statusId={"suggested"}
                    onClose={closeACB}
                />
          {rankedSuggestions.length === 0 && (
            <div className="text-center py-12 bg-amber-50 rounded-xl !border border-amber-200">
              <BookOpen className="w-12 h-12 text-amber-300 mx-auto mb-3" />
              <p className="text-amber-600">
                {isVotingActive 
                  ? 'No book suggestions yet. Be the first to suggest one!' 
                  : (props.isAdmin ? 'No active voting period. Start a new voting period below.' : 'No active voting period. Please wait for the admin to start a new voting period.')}
              </p>
              {props.isAdmin && !isVotingActive && (
                <button
                  onClick={() => setShowStartVotingPopUp(true)}
                  className="mt-4 px-4 py-2 bg-amber-500 text-white !rounded-lg hover:bg-amber-600 transition-colors"
                >
                  Start New Voting Period
                </button>
              )}
            </div>
          )}
        </div>
      </div>
      <StartVotingPopUp
        show={showStartVotingPopUp}
        setShow={setShowStartVotingPopUp}
        onStartVotingPeriod={(date) => props.onStartVotingPeriod(date)}
      />
    </div>
  );
}     
export default RankedList;